<div *ngIf="loading" class="in modal-backdrop spinner-overlay"></div>
<div *ngIf="loading" class="spinner-message-container" aria-live="assertive" aria-atomic="true">
    <div class="spinner-message" [ngClass]="spinnerMessageClass">{{ state.message | transloco }}</div>
</div>